import React from "react";
import ReactPaginate from "react-paginate";

type Props = {
  pageCount: number;
  pageOffset?: number | undefined;
  handleOnPageChange: (event: any) => void;
};

const TablePagination: React.FC<Props> = (props: Props) => {
  const { pageCount, pageOffset, handleOnPageChange } = props;

  return (
    <>
      <ReactPaginate
        nextLabel="Next"
        onPageChange={handleOnPageChange}
        pageRangeDisplayed={1}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        forcePage={pageOffset}
        previousLabel="Previous"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
};

export default TablePagination;
